import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CoreCommonModule } from '@core/common.module';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { MiscellaneousModule } from './miscellaneous/miscellaneous.module';
import { FlexibleBenefitsComponent } from './flexible-benefits/flexible-benefits.component';
import { FixedBenefitsComponent } from './fixed-benefits/fixed-benefits.component';
import { BenefitsHistoryComponent } from './benefits-history/benefits-history.component';
import { FlexibleBenefitsInfoComponent } from './flexible-benefits/flexible-benefits-info/flexible-benefits-info.component';
import { RouterModule, Routes } from '@angular/router';
import { CoreTouchspinModule } from '../../../@core/components/core-touchspin/core-touchspin.module';
import { SharedModule } from '../shared/shared.module';
import { ProfileComponent } from './profile/profile.component';
import { AddCardComponent } from './profile/add-card/add-card.component';
import { AddAddressComponent } from './profile/add-address/add-address.component';
import { FixedBenefitsInfoComponent } from './fixed-benefits/fixed-benefits-info/fixed-benefits-info.component';
import { TranslateModule } from '@ngx-translate/core';
import { AddBeneficiaryComponent } from './benefit-summary/add-beneficiary/add-beneficiary.component';
import { ChartsModule } from 'ng2-charts';
import { ReturnPaymentComponent } from './return-payment/return-payment.component';
import { BenefitDetailsService } from 'app/core/service/benefit-details.service';
import { FlexibleSupplierInfoComponent } from './flexible-benefits/flexible-supplier-info/flexible-supplier-info.component';
import { OrderableByNiceNamePipe } from 'app/core/pipes/orderable-by-nice-name.pipe';
import { OrderableByGroupingPipe } from 'app/core/pipes/orderable-by-nice-name.pipe';
import { BenefitAvailabilityComponent } from './flexible-benefits/benefit-availability/benefit-availability.component';
import { SidebarFiltersComponent } from './flexible-benefits/sidebar-filters/sidebar-filters.component';
import { SidebarCategoryFiltersComponent } from './flexible-benefits/sidebar-category-filters/sidebar-category-filters.component';
import { SidebarBudgetsFilterComponent } from './flexible-benefits/sidebar-budgets-filter/sidebar-budgets-filter.component';
import { QuillModule } from 'ngx-quill';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { BenefitsFilterComponent } from './flexible-benefits/benefits-filter/benefits-filter.component';
import { BenefitHistoryDetailsComponent } from './benefits-history/benefit-history-details/benefit-history-details.component';
import { CashbackShopListComponent } from './cashback/cashback-shop-list/cashback-shop-list.component';
import { CashbackShopDetailsComponent } from './cashback/cashback-shop-details/cashback-shop-details.component';
import { CashbackOfferDetailsComponent } from './cashback/cashback-offer-details/cashback-offer-details.component';
import { MobileAppUpdateComponent } from './mobile-app-update/mobile-app-update.component';
import { CashbackShopFilterComponent } from './cashback/cashback-shop-filter/cashback-shop-filter.component';
import { SidebarCashbackShopCategoryFilterComponent } from './cashback/sidebar-cashback-shop-category-filter/sidebar-cashback-shop-category-filtercomponent';
import { ParentCategoryComponent } from './flexible-benefits/sidebar-category-filters/parent-category/parent-category.component';
import { SidebarLocationFilterComponent } from './flexible-benefits/sidebar-location-filter/sidebar-location-filter.component';
import { BenefitHistoryStatusComponent } from './benefits-history/benefit-history-status/benefit-history-status.component';
import { BenefitHistoryInfoComponent } from './benefits-history/benefit-history-info/benefit-history-info.component';
import { BenefitDetailsTaxSourceComponent } from './benefits-history/benefit-details-tax-source/benefit-details-tax-source.component';
import { BenefitDetailsPaymentHistoryComponent } from './benefits-history/benefit-details-payment-history/benefit-details-payment-history.component';
import { BenefitDetailsCardPaymentHistoryComponent } from './benefits-history/benefit-details-card-payment-history/benefit-details-card-payment-history.component';
import { AutoOrderComponent } from "./auto-order/auto-order.component";
import { AutoOrderPaymentsTableComponent } from './auto-order/auto-order-payments-table/auto-order-payments-table.component';
import { AutoOrderSummaryComponent } from './auto-order/auto-order-summary/auto-order-summary.component';
import { ExpenseReportHistoryDetailsComponent } from './benefits-history/expense-report-history-details/expense-report-history-details.component';
import { BenefitConfirmModalComponent } from './flexible-benefits/benefit-confirm-modal/benefit-confirm-modal.component';
import { InsuranceHistoryTableComponent } from './benefits-history/insurance-history-table/insurance-history-table.component';
import { InsuranceDetailsComponent } from "./benefits-history/insurance-details-modal/insurance-details.component";

const appRoutes: Routes = [

];

@NgModule({
  declarations: [
    FlexibleBenefitsComponent,
    FixedBenefitsComponent,
    BenefitsHistoryComponent,
    FlexibleBenefitsInfoComponent,
    FlexibleSupplierInfoComponent,
    ProfileComponent,
    AddCardComponent,
    AddAddressComponent,
    FixedBenefitsInfoComponent,
    AddBeneficiaryComponent,
    ReturnPaymentComponent,
    BenefitAvailabilityComponent,
    OrderableByNiceNamePipe,
    OrderableByGroupingPipe,
    SidebarFiltersComponent,
    SidebarCategoryFiltersComponent,
    SidebarBudgetsFilterComponent,
    SidebarCashbackShopCategoryFilterComponent,
    BenefitsFilterComponent,
    CashbackShopFilterComponent,
    BenefitHistoryDetailsComponent,
    CashbackShopListComponent,
    CashbackShopDetailsComponent,
    CashbackOfferDetailsComponent,
    MobileAppUpdateComponent,
    ParentCategoryComponent,
    SidebarLocationFilterComponent,
    BenefitHistoryStatusComponent,
    BenefitHistoryInfoComponent,
    BenefitDetailsTaxSourceComponent,
    BenefitDetailsPaymentHistoryComponent,
    BenefitDetailsCardPaymentHistoryComponent,
    AutoOrderComponent,
    AutoOrderPaymentsTableComponent,
    AutoOrderSummaryComponent,
    ExpenseReportHistoryDetailsComponent,
    BenefitConfirmModalComponent,
    InsuranceHistoryTableComponent,
    InsuranceDetailsComponent
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    ContentHeaderModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    AuthenticationModule,
    MiscellaneousModule,
    RouterModule.forChild(appRoutes),
    CoreTouchspinModule,
    SharedModule,
    TranslateModule,
    ChartsModule,
    QuillModule,
    PerfectScrollbarModule
  ],
  exports: [RouterModule, BenefitDetailsTaxSourceComponent, BenefitDetailsPaymentHistoryComponent, BenefitDetailsCardPaymentHistoryComponent, AutoOrderComponent, BenefitHistoryStatusComponent, AutoOrderPaymentsTableComponent, AutoOrderSummaryComponent, InsuranceHistoryTableComponent, InsuranceDetailsComponent],
  providers: [
    BenefitDetailsService,
  ],
})
export class PagesModule {}
